export default {"src":"/_next/static/media/wallet.a0756afe.svg","height":22,"width":25,"blurWidth":0,"blurHeight":0};